// src/core/domain/collections.js
//
// Generic collection utilities. No React, no styles, no I/O.
// Universal — usable by any component, not tied to a region or feature.

export const dedupeBy = (items, keyFn) => {
  const seen = new Set();
  return items.filter(item => {
    const key = keyFn(item);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

export const compareAlphanumeric = (a, b) =>
  String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });

// Wrap-around navigation index. direction: +1 (next) or -1 (previous).
export const cycleIndex = (current, length, direction) => {
  if (length === 0) return 0;
  return (current + direction + length) % length;
};